import { useMemo } from 'react';
import { PERMISSIONS } from '../config/permissions';
import { useAuthStore } from '../stores/authStore';

export function usePermissions() {
    const user = useAuthStore((state) => state.user);

    const permissions = useMemo(() => {
        return user?.permissions || [];
    }, [user]);

    const role = user?.role || null;

    const hasPermission = (code) => {
        if (permissions.includes(PERMISSIONS.ADMIN.ALL)) return true;
        return permissions.includes(code);
    };

    const hasSome = (codes) => {
        if (permissions.includes(PERMISSIONS.ADMIN.ALL)) return true;
        return codes.some((c) => permissions.includes(c));
    };

    const hasAll = (codes) => {
        if (permissions.includes(PERMISSIONS.ADMIN.ALL)) return true;
        return codes.every((c) => permissions.includes(c));
    };

    return {
        role,
        permissions,
        loading: false,
        hasPermission,
        hasSome,
        hasAll,
    };
}
